import React, { useState, useRef, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { Search, X } from 'lucide-react';

// Recherche de villes / rues (Nominatim OpenStreetMap) avec recentrage de la carte.
const MapSearchControl = () => {
    const map = useMap();
    const boxRef = useRef(null);
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [searching, setSearching] = useState(false);

    useEffect(() => {
        if (boxRef.current) {
            L.DomEvent.disableClickPropagation(boxRef.current);
            L.DomEvent.disableScrollPropagation(boxRef.current);
        }
    }, []);

    const search = async (e) => {
        e.preventDefault();
        if (!query.trim()) return;
        setSearching(true);
        try {
            const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=6&accept-language=fr&q=${encodeURIComponent(query)}`);
            setResults(await res.json());
        } catch {
            setResults([]);
        } finally {
            setSearching(false);
        }
    };

    const goTo = (r) => {
        const zoom = ['city', 'town', 'village', 'municipality'].includes(r.type) ? 13 : 17;
        map.flyTo([parseFloat(r.lat), parseFloat(r.lon)], zoom, { duration: 1.2 });
        setResults([]);
    };

    return (
        <div ref={boxRef} className="leaflet-top leaflet-left" style={{ marginTop: 10, marginLeft: 50, pointerEvents: 'auto' }}>
            <div className="leaflet-control" style={{ width: 300 }}>
                <form onSubmit={search} className="flex items-center gap-1 bg-white rounded-md shadow-lg border border-zinc-300 px-2 py-1">
                    <Search className="w-4 h-4 text-zinc-500 flex-shrink-0" />
                    <input
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Rechercher une ville, une rue..."
                        className="flex-1 text-sm text-zinc-900 bg-transparent outline-none py-1"
                        data-testid="map-search-input"
                    />
                    {query && <button type="button" onClick={() => { setQuery(''); setResults([]); }} className="text-zinc-400 hover:text-zinc-700"><X className="w-3.5 h-3.5" /></button>}
                    <button type="submit" className="text-xs font-semibold text-blue-600 hover:text-blue-800 px-1" data-testid="map-search-btn">
                        {searching ? '...' : 'OK'}
                    </button>
                </form>
                {results.length > 0 && (
                    <div className="mt-1 bg-white rounded-md shadow-lg border border-zinc-300 overflow-hidden" data-testid="map-search-results">
                        {results.map(r => (
                            <button key={r.place_id} onClick={() => goTo(r)}
                                className="block w-full text-left px-3 py-2 text-xs text-zinc-800 hover:bg-blue-50 border-b border-zinc-100 last:border-0">
                                {r.display_name}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MapSearchControl;
